import type { InsurerDiscount } from 'BrokerTsLib/src/dtos'

export type NewPoleasImport = {
  name?: string // Název importu
  type?: number // typ importuVehicleInfo
  // pojišťovny
  file?: File
  insurers: number[]
  insurerDiscounts: InsurerDiscount[]
}

export type NewPoleasImportResponse = {
  importId: number
  offerCount: number
}

export type PoleasImportPreviewRequest = {
  importId: number
  hubId: string
}

export type PoleasImportPreviewRow = {
  leasingContractNumber?: string
  vin?: string
  vehicleInfo?: string
  policyHolderInfo?: string
  error?: string
}

export type PoleasImportRequest = {
  importId: number
  hubId: string
}

export type RowImportStatus = {
  ok: boolean
  errorMessage?: string
}

export const DisableReasonValue = {
  ClientDontWantToBeContacted: 1,
  Other: 100
} as const

export type DisableReasonValue = typeof DisableReasonValue[keyof typeof DisableReasonValue]

export type ClientDisabledRequest = {
  paramsId: string
  disableReason: DisableReasonValue
  disableReasonText?: string
}

export type PoleasPublicWizardLoginInfo = {
  pastInsuranceEnd: Date
  isRcLoginType: boolean
}

export type PoleasPublicSignInOptions = {
  ic?: string
  rc?: string
}

export type PoleasPublicBasicContacts = {
  phone?: string | null
  mobilePhone?: string | null
  mobilePhonePrefix?: string | null
  email?: string | null
  isContracted?: boolean | null
  clientDisabled?: boolean | null
  lastWizardStep?: number | null
}